import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
	const attorneyLogoSliders = document.querySelectorAll('.lawyer-logos .logos-swiper');

	attorneyLogoSliders.forEach((logoSlider) => {
		const lawyerSection = logoSlider.closest('.lawyer-logos');
		const prevBtn = lawyerSection?.querySelector('.logo-prev');
		const nextBtn = lawyerSection?.querySelector('.logo-next');
		const wrapper = logoSlider.querySelector('.swiper-wrapper');
		const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

		if (!originalSlides.length || !prevBtn || !nextBtn) return;

		function setNavVisible(isVisible) {
			[prevBtn, nextBtn].forEach(btn => {
				btn.disabled = !isVisible;
				btn.hidden = !isVisible;
				btn.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
			});

			logoSlider.classList.toggle('is-static', !isVisible);
		}

		new Swiper(logoSlider, {
			modules: [Navigation],
			loop: false,
			slidesPerGroup: 1,
			speed: 400,
			watchOverflow: true,
			breakpoints: {
				0:    { slidesPerView: 1, spaceBetween: 20 },
				600:  { slidesPerView: 2, spaceBetween: 30 },
				768:  { slidesPerView: 3, spaceBetween: 30 },
				1024: { slidesPerView: 4, spaceBetween: 40 },
			},
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			on: {
				init(swiper) {
					setNavVisible(!swiper.isLocked);
				},
				lock() {
					setNavVisible(false);
				},
				unlock(swiper) {
					setNavVisible(true);
					swiper.navigation.update();
				},
			},
		});
	});
});
